import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/images/logo/logo.svg';
import styles from './styles.module.scss';

export function NotFound() {
  const { t } = useTranslation();

  return (
    <div>
      <Helmet>
        <title>404 - Maintenance</title>
      </Helmet>
      <main className={styles.container}>
        <div>
          <div className={styles.header}>
            <img src={logo} alt="logo" />
            <h1>{t('maintenance_mode_page.header')}</h1>
          </div>
          <h4>{t('maintenance_mode_page.description')}</h4>
        </div>
      </main>
    </div>
  );
}

export default NotFound;
